import { customAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const mitre = defineConnector({
  identifier: "mitre",
  name: "MITRE ATT&CK",
  tagLine: "Threat intelligence knowledge base",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://.*\\.mitre\\.org/.*",
  auth: customAuth("noop"),
  steps: [
    {
      title: "No authentication required",
      items: [
        {
          kind: "markdown",
          content:
            "The MITRE ATT&CK TAXII server is publicly accessible. No API key is needed. This connector proxies requests to the MITRE TAXII and ATT&CK APIs.",
        },
      ],
    },
  ],
  customizeStepHandledInline: true,
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://attack-taxii.mitre.org/taxii2/",
      headers: {
        Accept: "application/taxii+json;version=2.1",
      },
    }),
  },
});
